import { db, storage, auth } from '../firebase/firebase';
import {
  SET_NAME,
  SET_USERNAME,
  FETCH_USERNAME_START,
  FETCH_USERNAME_COMPLETE,
  FETCH_USERNAME_ERROR,
  UPLOAD_STARTED,
  UPLOAD_PROGRESS,
  UPLOAD_COMPLETE,
  UPLOAD_FAIL,
  GET_PHOTO_SUCCESS,
  GET_PHOTO_PENDING,
  USER_PHOTO_SAVED,
  AVATAR_SAVE_START,
  AVATAR_SAVE_COMPLETE,
  AVATAR_SAVE_FAIL,
  USER_DETAIL_SAVE_START,
  USER_DETAIL_SAVE_SUCCESS,
  USER_DETAIL_SAVE_ERROR,
  FETCH_USER_START,
  FETCH_USER_COMPLETE,
  FETCH_USER_ERROR,
  SAVE_LINK_START,
  SAVE_LINK_COMPLETE,
  SAVE_LINK_ERROR,
  UPDATE_LINK_START,
  UPDATE_LINK_COMPLETE,
  UPDATE_LINK_ERROR,
  DELETE_LINK_START,
  DELETE_LINK_COMPLETE,
  DELETE_LINK_ERROR,
  SET_USER_STATUS,
  USERNAME_EXISTS_ERROR,
} from 'constants/types';

export const getUserData = (username) => {
  return dispatch => {
    dispatch({ type: FETCH_USER_START });

    auth.onAuthStateChanged(user => {
      if (user) {
        const id = user.uid;

        db.collection('users').doc(id).get()
          .then(result => {
            const dbUsername = result.data().username;

            if (dbUsername === username) {
              dispatch({
                type: SET_USER_STATUS,
                payload: true,
              })
            } else {
              dispatch({
                type: SET_USER_STATUS,
                payload: false,
              })
            }
          })
      } else {
        dispatch({
          type: SET_USER_STATUS,
          payload: false,
        })
      }
    });

    db.collection('users').where('username', '==', username).get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const user = doc.data();

          dispatch({
            type: FETCH_USER_COMPLETE,
            payload: user,
          })
        })
      })
      .catch(err => {
        console.error(err);
        dispatch({ type: FETCH_USER_ERROR });
      });
  }
};

export const saveLink = (title, url, linkId) => {
  return dispatch => {
    dispatch({ type: SAVE_LINK_START });

    const link = {
      title,
      url,
      id: linkId,
    };

    auth.onAuthStateChanged(user => {
      if (user) {
        const userId = user.uid;
        const userRef = db.collection('users').doc(userId);

        db.runTransaction(transaction => {
          return transaction.get(userRef)
            .then(doc => {
              if (!doc.data().links) {
                transaction.set(userRef, {
                  links: [link],
                }, { merge: true });
              } else {
                const links = doc.data().links;
                const newLinks = [...links, link];

                transaction.update(userRef, { links: newLinks });
              }
            })
            .then(() => {
              dispatch({
                type: SAVE_LINK_COMPLETE,
                payload: link,
              })
            })
            .catch(err => {
              dispatch({ type: SAVE_LINK_ERROR });
              console.error(err);
            })
        })
      }
    });
  }
};

export const editLink = (title, url, linkId) => {
  return dispatch => {
    dispatch({ type: UPDATE_LINK_START });

    const link = {
      title,
      url,
      id: linkId,
    };

    auth.onAuthStateChanged(user => {
      if (user) {
        const userId = user.uid;
        const userRef = db.collection('users').doc(userId);

        db.runTransaction(transaction => {
          return transaction.get(userRef)
            .then(doc => {
              const links = doc.data().links;
              const filteredLinks = links.filter(link => {
                return link.id !== linkId;
              });
              const updatedLinks = [...filteredLinks, link];

              transaction.update(userRef, { links: updatedLinks });
            })
            .then(() => {
              dispatch({
                type: UPDATE_LINK_COMPLETE,
                payload: link,
              })
            })
            .catch(err => {
              dispatch({ type: UPDATE_LINK_ERROR });
              console.error(err);
            })
        })
      }
    })
  }
};

export const deleteLink = (linkId) => {
  return dispatch => {
    dispatch({ type: DELETE_LINK_START });

    auth.onAuthStateChanged(user => {
      if (user) {
        const userId = user.uid;
        const userRef = db.collection('users').doc(userId);

        db.runTransaction(transaction => {
          return transaction.get(userRef)
            .then(doc => {
              const links = doc.data().links;
              const filteredLinks = links.filter(link => {
                return link.id !== linkId;
              });

              transaction.update(userRef, {
                links: filteredLinks,
              });
            })
            .then(() => {
              dispatch({
                type: DELETE_LINK_COMPLETE,
                payload: linkId,
              })
            })
            .catch(err => {
              dispatch({ type: DELETE_LINK_ERROR });
              console.error(err);
            })
        })

      }
    })
  }
};

export const updateName = (userId, name) => {
  return dispatch => {
    db.collection('users').doc(userId).set({ name }, { merge: true })
      .then(() => {
        dispatch({
          type: SET_NAME,
          payload: name,
        })
      })
      .catch((error) => {
        console.error(error);
      })
  }
};

export const getName = (userId) => {
  return dispatch => {
    db.collection('users').doc(userId).get()
      .then(data => {
        const user = data.data();
        const name = user.name;
        const firstName = name.split(' ')[0];

        dispatch({
          type: SET_NAME,
          payload: firstName,
        })
      })
      .catch(error => {
        console.error(error);
      });
  }
};

export const saveUsername = (userId, username, history) => {
  return dispatch => {
    const userRef = db.collection('users').doc(userId);

    userRef.set({ username }, { merge: true })
      .then(() => {
        dispatch({
          type: SET_USERNAME,
          payload: username,
        });
        history.push('/add_photo');
      })
      .catch((error) => {
        console.error(error);
      });
  }
};

export const getUsername = () => {
  return dispatch => {
    dispatch({ type: FETCH_USERNAME_START });
    auth.onAuthStateChanged(user => {
      if (user) {
        const userId = user.uid;

        db.collection('users').doc(userId).get()
          .then(userData => {
            const username = userData.data().username;

            dispatch({
              type: FETCH_USERNAME_COMPLETE,
              payload: username
            })
          })
          .catch(err => {
            dispatch({ type: FETCH_USERNAME_ERROR });
            console.error(err);
          })
      } else {
        dispatch({ type: FETCH_USERNAME_ERROR });
      }
    })
  }
};

export const saveUserDetails = (userId, name, email, username, history) => {
  return dispatch => {
    dispatch({ type: USER_DETAIL_SAVE_START });

    db.collection('users').where('username', '==', username).get()
      .then(querySnapshot => {
        let usernameIsTaken = false;

        querySnapshot.forEach(doc => {
          if (doc.id !== userId) {
            usernameIsTaken = true;
          }
        });

        if (usernameIsTaken) {
          dispatch({ type: USERNAME_EXISTS_ERROR });
        } else {
          db.collection('users').doc(userId).set({
            name,
            email,
            username,
          }, { merge: true })
            .then(() => {
              history.push(`/${username}`);
              dispatch({ type: USER_DETAIL_SAVE_SUCCESS });
            })
            .catch(err => {
              dispatch({ type: USER_DETAIL_SAVE_ERROR });
              console.error(err);
            })
        }
      })
  }
};

// export const uploadPhoto = (userId, photo, history) => {
//   return dispatch => {
//     dispatch({ type: UPLOAD_STARTED });
//
//     const uuid =  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
//     const photoRef = storage.ref().child(`images/${uuid}`);
//     const task = photoRef.put(photo);
//
//     task.on('state_changed',
//       function (snapshot) {
//         const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//
//         dispatch({
//           type: UPLOAD_PROGRESS,
//           payload: percentage,
//         })
//       },
//
//       function () {
//         dispatch({ type: UPLOAD_FAIL })
//       },
//
//       function () {
//         dispatch({ type: UPLOAD_COMPLETE });
//         history.push('/photo_crop');
//         db.collection('users').doc(userId).set({ photo: photoRef.fullPath }, { merge: true })
//           .catch((error) => {
//             console.error(error);
//           })
//       }
//     );
//   }
// };

export const uploadPhoto = (photo, history) => {
  return dispatch => {
    dispatch({ type: UPLOAD_STARTED });

    const uuid =  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    const photoRef = storage.ref().child(`images/${uuid}`);
    const task = photoRef.put(photo);

    task.on('state_changed',
      function (snapshot) {
        const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

        dispatch({
          type: UPLOAD_PROGRESS,
          payload: percentage,
        })
      },

      function () {
        dispatch({ type: UPLOAD_FAIL })
      },

      function () {
        localStorage.setItem('photoRef', photoRef.fullPath);

        dispatch({
          type: UPLOAD_COMPLETE,
          payload: photoRef.fullPath
        });
        history.push('/photo_crop');
      }
    );
  }
};

export const photoSaved = (photoRef) => {
  return {
    type: USER_PHOTO_SAVED,
    payload: photoRef,
  }
};

export const saveUserPhoto = (userId, photoRef) => {
  return dispatch => {
    db.collection('users').doc(userId).set({ photo: photoRef }, { merge: true })
      .then(() => {
        dispatch(photoSaved(photoRef));
      })
      .catch(error => {
        console.error(error);
      })
  }

};

// export const getPhoto = (userId) => {
//   return dispatch => {
//     dispatch({
//       type: GET_PHOTO_PENDING
//     });
//     db.collection('users').doc(userId).get()
//       .then(doc => {
//         const photoRef = doc.data().photo;
//
//         storage.ref().child(photoRef).getDownloadURL()
//           .then(url => {
//             dispatch({
//               type: GET_PHOTO_SUCCESS,
//               payload: url,
//             })
//           })
//           .catch(error => {
//             console.error(error);
//           })
//       });
//   }
// };

export const getPhoto = (photoRef) => {
  return dispatch => {
    dispatch({
      type: GET_PHOTO_PENDING
    });
    storage.ref().child(photoRef).getDownloadURL()
      .then(url => {
        dispatch({
          type: GET_PHOTO_SUCCESS,
          payload: url,
        })
      })
      .catch(error => {
        console.error(error);
      })
  }
};

export const getUserPhoto = (userId) => {
  return dispatch => {
    dispatch({
      type: GET_PHOTO_PENDING
    });
    db.collection('users').doc(userId).get()
      .then(doc => {
        const photoRef = doc.data().photo;

        storage.ref().child(photoRef).getDownloadURL()
          .then(url => {
            dispatch({
              type: GET_PHOTO_SUCCESS,
              payload: url,
            })
          })
          .catch(error => {
            console.error(error);
          })
      });
  }
}

// export const saveAvatar = (userId, image, history) => {
//   return dispatch => {
//     db.collection('users').doc(userId).get()
//       .then(doc => {
//         const photoRef = doc.data().photo;
//
//         storage.ref().child(photoRef).put(image)
//           .then(url => {
//             history.push('/share');
//           })
//           .catch((error) => {
//             console.error(error);
//           })
//       });
//   }
// };

export const saveAvatar = (photoRef, image, history) => {
  return dispatch => {
    dispatch({ type: AVATAR_SAVE_START });
    storage.ref().child(photoRef).put(image)
      .then(() => {
        history.push('/signup');
        dispatch({ type: AVATAR_SAVE_COMPLETE });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: AVATAR_SAVE_FAIL });
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js